import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap, withLatestFrom, catchError } from 'rxjs/operators';
import * as UserActions from './../actions/user.actions';
import { selectUserState } from './../selectors/user.selectors';
import { of } from 'rxjs';

@Injectable()
export class UserEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  persistUserState$ = createEffect(
    () => this.actions$.pipe(
      ofType(UserActions.login, UserActions.logout),
      withLatestFrom(this.store.select(selectUserState)),
      tap(([action, userState]) => {
        try {
          if (userState?.user) {
            localStorage.setItem('user', JSON.stringify(userState.user));
          }
        } catch (error) {
          console.error('Error persisting user state', error);
        }
      }),
      catchError((error) => {
        console.error('Error in persistUserState effect', error);
        return of(null);
      })
    ),
    { dispatch: false }
  );
}